// Typelizer digest 67a7aacba4d3f33cab937e1bfe9eef47
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/specialities */
  index: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/specialities */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/specialities/new */
  new: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities/new', params, options),
    method: 'get',
  }),

  /** GET /educators/teachers/:teacher_id/specialities/:id/edit */
  edit: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/specialities/:id */
  update: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /educators/teachers/:teacher_id/specialities/:id */
  destroy: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/specialities/:id', params, options),
    method: 'delete',
  }),
}
